// src/mixins/resultModal.mixin.js
export default {
    data() {
      return {
        resultModal: {
          open: false,
          payload: null,
          queue: [],
          _timer: null,
        },
      };
    },

    
    provide() {
      return {
        $resultModal: {
          open: (payload) => this.openResultModal(payload),
          close: () => this.closeResultModal(),
        },
      };
    },
    methods: {
      openResultModal(payload) {
        const p = Object.assign({
          status: 'neutral',
          title: '',
          message: '',
          messageParams: {},
          actions: null,
          closable: true,
          icon: null,
          autoCloseMs: undefined,
          source: 'component',
          onAction: null,
          onClose: null,
        }, payload || {});
  
        console.log(`new response`, p);
        if (this.resultModal.open) {
          let exist = this.resultModal.queue.find(el => el.title == p.title && el.message == p.message);
          if(!exist) this.resultModal.queue.push(p);
          return;
        }
        this._setResultModal(p);
      },
      closeResultModal() {
        const p = this.resultModal.payload;
        console.log(`response timeout`, p);
        if (this.resultModal._timer) {
          clearTimeout(this.resultModal._timer);
          this.resultModal._timer = null;
        }
        this.resultModal.open = false;
        this.resultModal.payload = null;
        try { p?.onClose && p.onClose(); } catch (e) { console.error(e); }
        const next = this.resultModal.queue.shift();
        if (next && next.title != p.title && next.message != p.message) this._setResultModal(next);
      },
      onResultAction(key) {
        const p = this.resultModal.payload;
        try { p?.onAction && p.onAction(key); } catch (e) { console.error(e); }
        this.closeResultModal();
      },
      _setResultModal(p) {
        this.resultModal.payload = p;
        this.resultModal.open = true;
        if (typeof p.autoCloseMs === 'number' && p.autoCloseMs > 0) {
          this.resultModal._timer = setTimeout(() => this.closeResultModal(), p.autoCloseMs);
        }
      },
    },
  };
  